import { useLanguage } from '../contexts/LanguageContext';
import { FileText } from 'lucide-react';

const ScriptManager = () => {
  const { t } = useLanguage();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-heading text-3xl font-black tracking-tight text-[#EDEDED]">
          {t('Script Manager', 'مدير النصوص')}
        </h2>
        <p className="text-[#A1A1AA] mt-1">
          {t('Write and manage bilingual video scripts', 'كتابة وإدارة نصوص الفيديو ثنائية اللغة')}
        </p>
      </div>

      <div className="text-center py-20 bg-carbon border border-[#27272A] rounded-lg">
        <FileText className="w-16 h-16 text-[#52525B] mx-auto mb-4" />
        <p className="text-[#A1A1AA] text-lg">{t('Coming Soon', 'قريبا')}</p>
      </div>
    </div>
  );
};

export default ScriptManager;
